import * as Joi from 'joi';
import { validateSingaporeCountry } from '../../../utils/JoiUtils';

const CompleteProfileDetailsScheme = Joi.object({
  salutation: Joi.object().required().messages({
    'object.base': 'Please select salutation',
  }),
  designation: Joi.object().required().messages({
    'object.base': 'Please select designation',
  }),
  countryCode: Joi.object().required().messages({
    'object.base': 'Please select country code',
  }),
  number: Joi.when('countryCode', {
    is: validateSingaporeCountry,
    then: Joi.string().max(8).min(8).required().messages({
      'string.empty': 'Please enter contact number',
      'string.max': 'Contact number is too long',
      'string.min': 'Contact number is too short',
    }),
    otherwise: Joi.string().max(15).required().messages({
      'string.empty': 'Please enter contact number',
      'string.max': 'Contact number is too long',
    }),
  }),
});

export default CompleteProfileDetailsScheme;
